import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, type FormInstance, Switch } from 'antd';
import type { FormProdutoValues } from '@/features/produto/types/FormProdutoValues';
import type { OrdenarLotes } from '@/features/produto/types/OrdenarLotes';
import type { ProdutoBodyEstoque, ProdutoBodyLote } from '@/features/produto/types/ProdutoBody';
import { useQueryProdutoLocalEstoqueGet } from '@/features/produto-local-estoque/api/apiProdutoLocalEstoqueGet';
import { ProdutoLoteStatus } from '@/features/produto/types/ProdutoLote';
import { useDialog } from '@/std/dialog/useDialog';
import { uuid } from '@/std/util';
import { ProdutoTabEstoqueLoteModal } from './ProdutoTabEstoqueLoteModal';
import { ProdutoTabEstoqueLoteResumo } from './ProdutoTabEstoqueLoteResumo';
import { ProdutoTabEstoqueLoteTable } from './ProdutoTabEstoqueLoteTable';

export function ProdutoTabEstoqueLote({
    form,
    ordenarLotes,
    setFormDirty,
}: {
    form: FormInstance<FormProdutoValues>;
    ordenarLotes: OrdenarLotes;
    setFormDirty: (dirty: boolean) => void;
}) {
    const produtoEstoque: ProdutoBodyEstoque[] = Form.useWatch('produto_estoque', form) ?? [];
    const lotes: ProdutoBodyLote[] = Form.useWatch('lote', form) ?? [];

    const dialog = useDialog<ProdutoBodyLote>();

    const { data } = useQueryProdutoLocalEstoqueGet();

    const adicionar = (): void => {
        dialog.actions.add({
            estoque: produtoEstoque
                .filter((estoque) => estoque.excluir !== 'S')
                .map((estoque) => ({
                    ple_estoque_atual: 0,
                    ple_estoque_idpk: estoque.pre_estoque_idpk,
                })),
            key: uuid(),
            prl_status: ProdutoLoteStatus.Ativo,
        });
    };

    return (
        <div className='flex flex-col gap-2'>
            <div className='grid grid-cols-[1fr_auto_1fr] items-center gap-4'>
                <Form.Item
                    getValueFromEvent={(checked) => (checked ? 'S' : 'N')}
                    getValueProps={(value) => ({ checked: value === 'S' })}
                    label='Ao vender este produto, solicitar lote'
                    layout='horizontal'
                    name='pro_lote_solicitar_venda'
                    style={{ marginBottom: 0 }}
                    tooltip='Após selecionar este produto na venda, outra tela se abrirá para ser informado o lote desejado do produto selecionado.'
                >
                    <Switch checkedChildren='Sim' unCheckedChildren='Não' />
                </Form.Item>

                <Button icon={<PlusOutlined />} onClick={adicionar} type='primary'>
                    Adicionar
                </Button>
            </div>

            <Form.Item hidden={true} name='lote' />

            <ProdutoTabEstoqueLoteTable
                dialog={dialog}
                form={form}
                locais={data?.registros ?? []}
                setFormDirty={setFormDirty}
            />

            {lotes.some((lote) => lote.excluir !== 'S') && (
                <ProdutoTabEstoqueLoteResumo
                    locais={data?.registros ?? []}
                    lotes={lotes}
                    produtoEstoque={produtoEstoque.filter((estoque) => estoque.excluir !== 'S')}
                />
            )}

            <ProdutoTabEstoqueLoteModal
                dialog={dialog}
                form={form}
                locais={data?.registros ?? []}
                ordenarLotes={ordenarLotes}
                setFormDirty={setFormDirty}
            />
        </div>
    );
}
